module.exports = __webpack_public_path__ + "image/header_logo10.png";